export const getDeterministicBackgroundImage = (
  key: string,
  backgroundImages: string[]
) => {
  if (!backgroundImages.length) return "";

  let hash = 0;
  for (let index = 0; index < key.length; index++) {
    hash = (hash * 31 + key.charCodeAt(index)) >>> 0;
  }

  return backgroundImages[hash % backgroundImages.length];
};
